import { DeployParams } from 'src/app/deployParams';
import { SiteViewConfiguration } from '../enums';
import { environment } from 'src/environments/environment';

/* eslint-disable @typescript-eslint/naming-convention */
export class ViewConfigurations {
  private static SHOW_COMPETITIONS_IN_SPORT_TREE = false;
  private static FAVORITE_SPORT_TREE_ELEMENTS_ENABLED = false;
  private static FAVORITE_EVENTS_ENABLED = false;
  private static SHOW_ONLY_SYSTEM_TICKET = false;
  private static USE_MOBILE_VIEW_WITH_TOP_MENU = false;
  private static SHOW_FILTER_NAVIGATION_MENU = false;
  private static USE_PAGE_TYPE_AND_TIME_FILTER_FROM_STORAGE = false;
  private static SHOW_ALL_EVENTS_BUTTON_ON_SELECTED_REGION = false;
  private static SHOW_SPORT_TITLE = true;
  private static SHOW_MOBILE_TICKET_DIALOG_V2 = false;
  private static SHOW_BONUS_MESSAGE_ON_SYSTEM_TICKET = true;
  private static REMOVE_TICKET_ITEMS_AFTER_TICKET_IS_PLAYED = true;
  private static USE_SOON_ON_TIME_FILTER_CHANGE = false;
  private static SHOW_BANNERS_DESKTOP = false;
  private static ADD_PROPERTIES_ON_TICKET_DIALOG = false;
  private static SHOW_SPORT_ICON_IN_TICKET = false;
  private static HIDE_EVENT_CODE_IN_EVENT = false;
  private static INCLUDE_RESULTS_PAGE = false;
  private static REDUCE_MY_TICKETS_FILTER = false;
  private static BET_TYPE_NAME_DESCRIPTION = false;
  private static SHOW_OPTIONS_ON_TICKET_DIALOG = true;
  private static TICKET_SHOW_POTENTAL_WIN_WITOUT_TAX = false;
  private static SHOW_MY_TICKET_BUTTON_ON_PLAYED_TICKET = false;
  private static WIDGET_LAYOUT_DOUBLE = true;
  private static DONT_REMOVE_FINISHED_LIVE_EVENT = true;
  private static SHOW_DIALOG_ON_ODD_CHANGE_BEFORE_PLACE_BET = false;
  private static SHOW_TIMER_ON_DIALOG = false;
  private static SAVE_ODDS_VALIDATION_MODE = false;
  private static SHOW_H2H_WIDGET_ON_DETAIL = false;
  private static SHOW_SPECIAL_EVENTS_IN_STANDARD_OFFER = true;
  private static SHOW_NUMBER_OF_HITS_FOR_SYSTEM_TICKET = false;
  private static ARE_LIVE_SPORTS_EXPANDED_ON_START = false;
  private static SHOW_SHORT_RESULT_AND_RESULT_ON_EXPAND_LIVE = true;
  private static USE_HADICAP_SBV_PIPE = false;
  private static SHOW_POT_FREE_BET_WINNINGS = true;
  private static SHOW_OUTRIGHTS_AT_END = false;
  private static ORDER_SPECIALS_BY_CODE = true;
  private static SHOW_PROMOTIONS_ON_MOBILE_MENU = false;
  private static SHOW_STATISTICS_IN_TREE = true;
  private static SHOW_ODD_SHEETS = true;
  private static SHOW_WIDGETS_ON_SITE = true;
  private static ADD_PLAYED_LIVE_EVENTS_TO_FAVORITE = false;
  private static HIDE_WIDGET_IF_NOT_LICENSED = false;
  private static HIDE_RESULT_OUTCOMES_IF_NO_ODD = false;
  private static DELAY_REMOVING_FINISHED_LIVE_EVENT_IN_MS = 10000;
  private static DISABLE_CASHIER_AND_SHOP_CREATION_BY_AGENT = true;
  private static ENABLE_MONEY_TRANSFER = true;
  private static SHOW_EXPORT_USERS_BUTTON = false;
  private static ENABLE_PAYSTACK = true;
  private static REQUEST_PIN_FOR_STORNO_AND_PAYOUT = true;
  private static ENABLE_FAST_TICKET_LIVE = false;
  private static ENABLE_AGENT_MANAGER = false;
  private static ENABLE_AGENT_PASSWORD_CHANGE = false;

  public static get agentPasswordChangeEnabled(): boolean {
    return this.ENABLE_AGENT_PASSWORD_CHANGE;
  }

  public static get agentManagerEnabled(): boolean {
    return this.ENABLE_AGENT_MANAGER;
  }

  public static get enableFastTicketLive(): boolean {
    return this.ENABLE_FAST_TICKET_LIVE;
  }

  public static get requestPinForStornoAndPayout(): boolean {
    return this.REQUEST_PIN_FOR_STORNO_AND_PAYOUT;
  }

  public static get isPaystackEnabled(): boolean {
    return this.ENABLE_PAYSTACK;
  }

  public static get showExportUsersButton(): boolean {
    return this.SHOW_EXPORT_USERS_BUTTON;
  }

  public static get isMoneyTransferEnabled(): boolean {
    return this.ENABLE_MONEY_TRANSFER;
  }

  public static get isShopAndCashierCreateDiabledToAgent(): boolean {
    return this.DISABLE_CASHIER_AND_SHOP_CREATION_BY_AGENT;
  }

  public static get timeToDelayRemovingFinishedLiveEvent(): number {
    return this.DELAY_REMOVING_FINISHED_LIVE_EVENT_IN_MS;
  }

  public static get hideResultOutcomesIfNoOdd(): boolean {
    return this.HIDE_RESULT_OUTCOMES_IF_NO_ODD;
  }

  public static get addPlayedLiveEventsToFavorite(): boolean {
    return this.ADD_PLAYED_LIVE_EVENTS_TO_FAVORITE;
  }

  public static get showPromotionsOnMobileMenu(): boolean {
    return this.SHOW_PROMOTIONS_ON_MOBILE_MENU;
  }

  public static get orderSpecialsByCode(): boolean {
    return this.ORDER_SPECIALS_BY_CODE;
  }

  public static get showPotentialFreeBetWinnings(): boolean {
    return this.SHOW_POT_FREE_BET_WINNINGS;
  }

  public static get showShortResultAndResultOnExpandLive(): boolean {
    return this.SHOW_SHORT_RESULT_AND_RESULT_ON_EXPAND_LIVE;
  }

  public static get useHandicapSbvPipe(): boolean {
    return this.USE_HADICAP_SBV_PIPE;
  }

  public static get areLiveSportsExpandedOnStart(): boolean {
    return this.ARE_LIVE_SPORTS_EXPANDED_ON_START;
  }

  public static get showNumberOfHitsForTicketSystem(): boolean {
    return this.SHOW_NUMBER_OF_HITS_FOR_SYSTEM_TICKET;
  }

  public static get showSpecialEventsInStandardOffer(): boolean {
    return this.SHOW_SPECIAL_EVENTS_IN_STANDARD_OFFER;
  }

  public static get useSavedOddsValidationMode(): boolean {
    return this.SAVE_ODDS_VALIDATION_MODE;
  }

  public static get showDialogOnOddChangeBeforePlaceBet(): boolean {
    return this.SHOW_DIALOG_ON_ODD_CHANGE_BEFORE_PLACE_BET;
  }

  public static get delayRemovingFinishedLiveEvent(): boolean {
    return this.DONT_REMOVE_FINISHED_LIVE_EVENT;
  }

  public static get addPropertiesOnticketDialog(): boolean {
    return this.ADD_PROPERTIES_ON_TICKET_DIALOG;
  }

  public static get showTicketDialogMobileV2(): boolean {
    return this.SHOW_MOBILE_TICKET_DIALOG_V2;
  }

  public static get showCompetitionsInSportTree(): boolean {
    return this.SHOW_COMPETITIONS_IN_SPORT_TREE;
  }

  public static get showFilterNavigationMenu(): boolean {
    return this.SHOW_FILTER_NAVIGATION_MENU;
  }

  public static get isFavoriteSportTreeElementsEnabled(): boolean {
    return this.FAVORITE_SPORT_TREE_ELEMENTS_ENABLED;
  }

  public static get isFavoriteEventsEnabled(): boolean {
    return this.FAVORITE_EVENTS_ENABLED;
  }

  public static get showOnlySystemTicket(): boolean {
    return this.SHOW_ONLY_SYSTEM_TICKET;
  }

  public static get useMobileViewWithTopMenu() {
    return this.USE_MOBILE_VIEW_WITH_TOP_MENU;
  }

  public static get usePageTypeAndTimeFilterFromStorage() {
    return this.USE_PAGE_TYPE_AND_TIME_FILTER_FROM_STORAGE;
  }

  public static get showAllEventsButtonOnSelectedRegion() {
    return this.SHOW_ALL_EVENTS_BUTTON_ON_SELECTED_REGION;
  }

  public static get showSportTitle() {
    return this.SHOW_SPORT_TITLE;
  }

  public static get showBonusMessageOnSystemTicket() {
    return this.SHOW_BONUS_MESSAGE_ON_SYSTEM_TICKET;
  }

  public static get removeTicektItemsAfterTicketIsPlayed() {
    return this.REMOVE_TICKET_ITEMS_AFTER_TICKET_IS_PLAYED;
  }

  public static get useSoonViewWhenTimeFilterIsChanged() {
    return this.USE_SOON_ON_TIME_FILTER_CHANGE;
  }

  public static get showBannersDesktop() {
    return this.SHOW_BANNERS_DESKTOP;
  }

  public static get showSportIconInTicket() {
    return this.SHOW_SPORT_ICON_IN_TICKET;
  }

  public static get hideEventCodeInEvent() {
    return this.HIDE_EVENT_CODE_IN_EVENT;
  }

  public static get includeResultsPage(): boolean {
    return this.INCLUDE_RESULTS_PAGE;
  }

  public static get reduceMyTicketsFilter(): boolean {
    return this.REDUCE_MY_TICKETS_FILTER;
  }

  public static get showBetTypeNameDescription(): boolean {
    return this.BET_TYPE_NAME_DESCRIPTION;
  }

  public static get showOptionsOnTicketDialog(): boolean {
    return this.SHOW_OPTIONS_ON_TICKET_DIALOG;
  }

  public static get ticketShowPotentalWinWitoutTax(): boolean {
    return this.TICKET_SHOW_POTENTAL_WIN_WITOUT_TAX;
  }

  public static get showMyTicketButtonOnPlayedTicket(): boolean {
    return this.SHOW_MY_TICKET_BUTTON_ON_PLAYED_TICKET;
  }

  public static get widgetLayoutDouble(): boolean {
    return this.WIDGET_LAYOUT_DOUBLE;
  }

  public static get showTimerOnDialog(): boolean {
    return this.SHOW_TIMER_ON_DIALOG;
  }

  public static get showH2HwidgetOnDetail(): boolean {
    return this.SHOW_H2H_WIDGET_ON_DETAIL;
  }

  public static get showOutrightsAtEnd(): boolean {
    return this.SHOW_OUTRIGHTS_AT_END;
  }

  public static get showStatisticsInTree(): boolean {
    return this.SHOW_STATISTICS_IN_TREE;
  }

  public static get showOddSheets(): boolean {
    return this.SHOW_ODD_SHEETS;
  }

  public static get showWidgetsOnSite(): boolean {
    return this.SHOW_WIDGETS_ON_SITE;
  }

  public static get hideWidgetIfNotLicensed(): boolean {
    return this.HIDE_WIDGET_IF_NOT_LICENSED;
  }

  public static setValues() {
    switch (environment.viewConfiguration) {
      case SiteViewConfiguration.SERBIA:
        this.SHOW_EXPORT_USERS_BUTTON = false;
        this.ENABLE_MONEY_TRANSFER = true;
        this.SHOW_COMPETITIONS_IN_SPORT_TREE = false;
        this.FAVORITE_SPORT_TREE_ELEMENTS_ENABLED = false;
        this.FAVORITE_EVENTS_ENABLED = false;
        this.SHOW_ONLY_SYSTEM_TICKET = false;
        this.USE_MOBILE_VIEW_WITH_TOP_MENU = false;
        this.SHOW_FILTER_NAVIGATION_MENU = false;
        this.USE_PAGE_TYPE_AND_TIME_FILTER_FROM_STORAGE = false;
        this.SHOW_ALL_EVENTS_BUTTON_ON_SELECTED_REGION = false;
        this.SHOW_SPORT_TITLE = true;
        this.SHOW_MOBILE_TICKET_DIALOG_V2 = false;
        this.SHOW_BONUS_MESSAGE_ON_SYSTEM_TICKET = true;
        this.REMOVE_TICKET_ITEMS_AFTER_TICKET_IS_PLAYED = true;
        this.USE_SOON_ON_TIME_FILTER_CHANGE = false;
        this.SHOW_BANNERS_DESKTOP = false;
        this.ADD_PROPERTIES_ON_TICKET_DIALOG = false;
        this.SHOW_SPORT_ICON_IN_TICKET = false;
        this.HIDE_EVENT_CODE_IN_EVENT = false;
        this.INCLUDE_RESULTS_PAGE = false;
        this.REDUCE_MY_TICKETS_FILTER = false;
        this.BET_TYPE_NAME_DESCRIPTION = false;
        this.SHOW_OPTIONS_ON_TICKET_DIALOG = true;
        this.TICKET_SHOW_POTENTAL_WIN_WITOUT_TAX = false;
        this.SHOW_MY_TICKET_BUTTON_ON_PLAYED_TICKET = false;
        this.WIDGET_LAYOUT_DOUBLE = true;
        this.DONT_REMOVE_FINISHED_LIVE_EVENT = true;
        this.SHOW_DIALOG_ON_ODD_CHANGE_BEFORE_PLACE_BET = false;
        this.SHOW_TIMER_ON_DIALOG = false;
        this.SAVE_ODDS_VALIDATION_MODE = false;
        this.SHOW_H2H_WIDGET_ON_DETAIL = false;
        this.SHOW_SPECIAL_EVENTS_IN_STANDARD_OFFER = true;
        this.SHOW_NUMBER_OF_HITS_FOR_SYSTEM_TICKET = false;
        this.ARE_LIVE_SPORTS_EXPANDED_ON_START = false;
        this.SHOW_SHORT_RESULT_AND_RESULT_ON_EXPAND_LIVE = true;
        this.USE_HADICAP_SBV_PIPE = false;
        this.SHOW_POT_FREE_BET_WINNINGS = true;
        this.SHOW_OUTRIGHTS_AT_END = false;
        this.ORDER_SPECIALS_BY_CODE = true;
        this.SHOW_PROMOTIONS_ON_MOBILE_MENU = false;
        this.SHOW_STATISTICS_IN_TREE = true;
        this.SHOW_ODD_SHEETS = true;
        this.SHOW_WIDGETS_ON_SITE = true;
        this.ADD_PLAYED_LIVE_EVENTS_TO_FAVORITE = false;
        this.HIDE_WIDGET_IF_NOT_LICENSED = false;
        this.HIDE_RESULT_OUTCOMES_IF_NO_ODD = false;
        this.DELAY_REMOVING_FINISHED_LIVE_EVENT_IN_MS = 10000;
        this.DISABLE_CASHIER_AND_SHOP_CREATION_BY_AGENT = true;
        break;
      case SiteViewConfiguration.CROATIA:
        this.SHOW_EXPORT_USERS_BUTTON = false;
        this.ENABLE_MONEY_TRANSFER = true;
        this.SHOW_COMPETITIONS_IN_SPORT_TREE = true;
        this.FAVORITE_SPORT_TREE_ELEMENTS_ENABLED = true;
        this.FAVORITE_EVENTS_ENABLED = true;
        this.SHOW_ONLY_SYSTEM_TICKET = true;
        this.USE_MOBILE_VIEW_WITH_TOP_MENU = true;
        this.SHOW_FILTER_NAVIGATION_MENU = true;
        this.USE_PAGE_TYPE_AND_TIME_FILTER_FROM_STORAGE = true;
        this.SHOW_ALL_EVENTS_BUTTON_ON_SELECTED_REGION = true;
        this.SHOW_SPORT_TITLE = false;
        this.SHOW_MOBILE_TICKET_DIALOG_V2 = true;
        this.SHOW_BONUS_MESSAGE_ON_SYSTEM_TICKET = false;
        this.REMOVE_TICKET_ITEMS_AFTER_TICKET_IS_PLAYED = false;
        this.USE_SOON_ON_TIME_FILTER_CHANGE = true;
        this.SHOW_BANNERS_DESKTOP = true;
        this.ADD_PROPERTIES_ON_TICKET_DIALOG = true;
        this.SHOW_SPORT_ICON_IN_TICKET = true;
        this.HIDE_EVENT_CODE_IN_EVENT = true;
        this.INCLUDE_RESULTS_PAGE = true;
        this.REDUCE_MY_TICKETS_FILTER = true;
        this.BET_TYPE_NAME_DESCRIPTION = true;
        this.SHOW_OPTIONS_ON_TICKET_DIALOG = false;
        this.TICKET_SHOW_POTENTAL_WIN_WITOUT_TAX = true;
        this.SHOW_MY_TICKET_BUTTON_ON_PLAYED_TICKET = true;
        this.WIDGET_LAYOUT_DOUBLE = false;
        this.DONT_REMOVE_FINISHED_LIVE_EVENT = true;
        this.SHOW_DIALOG_ON_ODD_CHANGE_BEFORE_PLACE_BET = true;
        this.SHOW_TIMER_ON_DIALOG = true;
        this.SAVE_ODDS_VALIDATION_MODE = true;
        this.SHOW_H2H_WIDGET_ON_DETAIL = true;
        this.SHOW_SPECIAL_EVENTS_IN_STANDARD_OFFER = false;
        this.SHOW_NUMBER_OF_HITS_FOR_SYSTEM_TICKET = true;
        this.ARE_LIVE_SPORTS_EXPANDED_ON_START = false;
        this.SHOW_SHORT_RESULT_AND_RESULT_ON_EXPAND_LIVE = false;
        this.USE_HADICAP_SBV_PIPE = true;
        this.SHOW_POT_FREE_BET_WINNINGS = false;
        this.SHOW_OUTRIGHTS_AT_END = true;
        this.ORDER_SPECIALS_BY_CODE = true;
        this.SHOW_PROMOTIONS_ON_MOBILE_MENU = false;
        this.SHOW_STATISTICS_IN_TREE = true;
        this.SHOW_ODD_SHEETS = true;
        this.SHOW_WIDGETS_ON_SITE = true;
        this.ADD_PLAYED_LIVE_EVENTS_TO_FAVORITE = true;
        this.HIDE_WIDGET_IF_NOT_LICENSED = true;
        this.HIDE_RESULT_OUTCOMES_IF_NO_ODD = true;
        this.DELAY_REMOVING_FINISHED_LIVE_EVENT_IN_MS = 30000;
        break;
      case SiteViewConfiguration.BIH:
        this.SHOW_EXPORT_USERS_BUTTON = false;
        this.ENABLE_MONEY_TRANSFER = true;
        this.SHOW_PROMOTIONS_ON_MOBILE_MENU = true;
        this.SHOW_STATISTICS_IN_TREE = false;
        this.SHOW_ODD_SHEETS = false;
        this.SHOW_WIDGETS_ON_SITE = false;
        this.ADD_PLAYED_LIVE_EVENTS_TO_FAVORITE = false;
        this.HIDE_WIDGET_IF_NOT_LICENSED = false;

        break;
      case SiteViewConfiguration.UGANDA:
        this.SHOW_EXPORT_USERS_BUTTON = false;
        this.ENABLE_MONEY_TRANSFER = true;
        this.ADD_PROPERTIES_ON_TICKET_DIALOG = true;
        this.TICKET_SHOW_POTENTAL_WIN_WITOUT_TAX = true;
        this.DISABLE_CASHIER_AND_SHOP_CREATION_BY_AGENT = true;
        this.ENABLE_AGENT_MANAGER = true;
        break;
      case SiteViewConfiguration.NIGERIA:
        this.REQUEST_PIN_FOR_STORNO_AND_PAYOUT = false;
        this.ENABLE_PAYSTACK = false;
        this.SHOW_EXPORT_USERS_BUTTON = true;
        this.ENABLE_MONEY_TRANSFER = false;
        this.ADD_PROPERTIES_ON_TICKET_DIALOG = true;
        this.TICKET_SHOW_POTENTAL_WIN_WITOUT_TAX = true;
        this.DISABLE_CASHIER_AND_SHOP_CREATION_BY_AGENT = true;
        this.ENABLE_FAST_TICKET_LIVE = true;
        this.ENABLE_AGENT_MANAGER = true;
        this.ENABLE_AGENT_PASSWORD_CHANGE = true;
        break;
      default:
        break;
    }
  }
}
